import React, { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import BootstrapTable from 'react-bootstrap-table-next';
import pagination from './pagination';
import "./Stax.css";
import { Roller } from "react-awesome-spinners";
import { get_client_frequency_report } from "../Api/crm";
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import { Modal, Form } from 'react-bootstrap';
import ChildComponent from '../Components/EditUser/Informasi';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CSVLink } from 'react-csv';
import { DateRangePicker } from 'react-date-range';
import moment from "moment-timezone";

import { notify } from "../utils/notify";

function CleaningFrequencyReport() {
    const [loading, setLoading] = useState(false);
    const [staxdata, setStaxdata] = useState([]);

    const [limit, setLimit] = useState(1);
    const [customer_stage, setCustomer_stage] = useState("");

    const getuserdata = () => {
        setLoading(true);
        const formData = new FormData();
        const startTime = moment(sdate).format("YYYY-MM-DD");
        const endTime = moment(edate).format("YYYY-MM-DD");
        formData.append("start_date", startTime);
        formData.append("end_date", endTime);
        formData.append("customer_stage", customer_stage);
        get_client_frequency_report(formData)
            .then((response) => {
                if (response.code === 200) {
                    const apiResponse = response.data;

                    // Check if the API status is success
                    if (apiResponse.status === 1) {
                        const fetchedMargedata = apiResponse.data;
                        setStaxdata(fetchedMargedata);
                    } else {
                        setStaxdata([]);
                    }
                } else {
                    setStaxdata([]);
                }
            })
            .catch(function (err) {
                // Handle network or unexpected errors
                console.error("Error fetching data:", err);
                notify.error("An error occurred while fetching data. Please check your connection or try again later.");
                setStaxdata([]);
            })
            .finally(() => {
                // Hide the loading spinner after the request completes
                setLoading(false);
            });
    };

    useEffect(() => {
        getuserdata();
    }, []);

    const columns = [
        {
            dataField: 'client_name',
            text: 'Client name',
            sort: true,
        },
        {
            dataField: 'current_stage',
            text: 'Current Stage',
            sort: false,
        },
        {
            dataField: 'billed_hours',
            text: 'Billed Hours',
            sort: true,
        },
        {
            dataField: 'frequency_days',
            text: 'Frequency AVG (Average number of days between cleanings in date range)',
            sort: true,
        },
        {
            dataField: 'potential_billed',
            text: 'Potential Billed',
            sort: true,
        }
    ];

    const csvReport = {
        data: staxdata.map(item => {
            return {
                client_name: (item.client_name || '').trim(),
                current_stage: (item.current_stage || '').trim(),
                billed_hours: (item.billed_hours || '').trim(),
                frequency_days: item.frequency_days,
                potential_billed: item.potential_billed
            };
        }),
        headers: [
            { label: "NAME", key: "client_name" },
            { label: "CURRENT STAGE", key: "current_stage" },
            { label: "BILLED HOURS", key: "billed_hours" },
            { label: "FREQUENCY AVG (Average number of days between cleanings in date range)", key: "frequency_days" },
            { label: "POTENTIAL BILLED", key: "potential_billed" },
        ],
        filename: 'Cleaning-frequency-report.csv'
    }

    const today = new Date();

    // current month ka 1st day
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    // current month ka last day
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const [sdate, setSdate] = useState(firstDayOfMonth);
    const [edate, setEdate] = useState(lastDayOfMonth);

    const [show9, setShow9] = useState(false);

    const handleClose9 = () => setShow9(false);
    const handleShow9 = () => setShow9(true);

    const [dates, setDates] = useState([
        {
            startDate: firstDayOfMonth,
            endDate: lastDayOfMonth,
            key: "selection",
        },
    ]);



    return (
        <div>
            {
                loading ? (
                    <div className="loading">
                        <Roller size={50} color="#75b317" />
                    </div>
                ) : (<>

                    <Modal show={show9} onHide={handleClose9} centered className="modal-center">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Filter data
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="date-picker">
                                        <Form.Group
                                            className="booking-custom-lable"
                                            controlId="formBasicEmail"
                                        >
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <DateRangePicker
                                                        onChange={(item) => {
                                                            //console.log("aminesh item:", item);
                                                            setSdate(item.selection.startDate);
                                                            setEdate(item.selection.endDate);
                                                            setDates([item.selection]);
                                                        }}
                                                        showSelectionPreview={true}
                                                        moveRangeOnFirstSelection={false}
                                                        // months={2}
                                                        ranges={dates}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="date-picker">
                                    <Form.Group
                                        className="booking-custom-lable"
                                        controlId="formBasicEmail"
                                    >
                                        <div className="toggle_btn">
                                            <button className="resize_btn btn" onClick={handleClose9}>
                                                <div className="btn-text">
                                                    Submit
                                                </div>
                                            </button>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>


                    <div className="dashboard-container d-flex">
                        <div className="sidebar-container">
                            <Sidebar />
                        </div>
                        <div className="main-container">
                            <div className="main-page-body-content">
                                {/* <div className="main-page-body-content-header">
                                    <Header />
                                </div> */}
                                <div className="main-page-body-content-body">
                                    <div className="main-page-body-content-body-container">
                                        <div className="container-fulid">
                                            <div className="">
                                                <div className="table-card ">
                                                    <div className="card-body table-card-body">
                                                        <div className="table-card-header">
                                                            <h5 className="card-title">Lillypad data</h5>
                                                        </div>
                                                        <div className="table-card-body-inner">
                                                            <div className="animated fadeIn">
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="card">
                                                                            <div className="card-header d-flex justify-content-between table-card-header" >
                                                                                <div className="card-header d-flex table-card-header justify-content-between align-items-center px-0">
                                                                                    <div className="ml-auto d-flex align-items-end">
                                                                                        <div className="d-flex flex-column">
                                                                                            {/* <label>
                                                                                                Older than
                                                                                            </label>
                                                                                            <select className="btn btn-sm ms-0 bg-secondary text-white"
                                                                                                style={{
                                                                                                    backgroundColor: '#75B317 !important',
                                                                                                    border: '1px solid #75B317 !important',
                                                                                                    height: '38px',
                                                                                                    // padding: '0px 20px',
                                                                                                    fontSize: '15px',
                                                                                                    fontWeight: '500',
                                                                                                    color: '#ffffff !important',
                                                                                                    margin: '0px 10px'
                                                                                                }}
                                                                                                value={limit} onChange={(e) => setLimit(e.target.value)}>
                                                                                                <option value={1}>1 Month</option>
                                                                                                <option value={2}>2 Month</option>
                                                                                                <option value={3}>3 Month</option>
                                                                                                <option value={4}>4 Month</option>
                                                                                                <option value={5}>5 Month</option>
                                                                                                <option value={6}>6 Month</option>
                                                                                                <option value={7}>7 Month</option>
                                                                                                <option value={8}>8 Month</option>
                                                                                                <option value={9}>9 Month</option>
                                                                                                <option value={10}>10 Month</option>
                                                                                                <option value={11}>11 Month</option>
                                                                                                <option value={12}>12 Month</option>
                                                                                            </select> */}
                                                                                            <Button
                                                                                                className="btn btn-sm float-right add-user-btn ms-0"
                                                                                                onClick={handleShow9}
                                                                                            >
                                                                                                Select range
                                                                                            </Button>
                                                                                        </div>
                                                                                        <div className="d-flex flex-column">
                                                                                            <label>
                                                                                                Customer Stage
                                                                                            </label>
                                                                                            <select className="btn btn-sm ms-0 bg-secondary text-white"
                                                                                                value={customer_stage} onChange={(e) => setCustomer_stage(e.target.value)}
                                                                                                style={{
                                                                                                    backgroundColor: '#75B317 !important',
                                                                                                    border: '1px solid #75B317 !important',
                                                                                                    height: '38px',
                                                                                                    // padding: '0px 20px',
                                                                                                    fontSize: '15px',
                                                                                                    fontWeight: '500',
                                                                                                    color: '#ffffff !important',
                                                                                                    margin: '0px 10px'
                                                                                                }}
                                                                                            >
                                                                                                <option value='all'>All</option>
                                                                                                <option value="New Lead">New Lead</option>
                                                                                                <option value="2nd Lead Contact Attempt">
                                                                                                    2nd Lead Contact Attempt
                                                                                                </option>
                                                                                                <option value="3nd Lead Contact Attempt">
                                                                                                    3nd Lead Contact Attempt
                                                                                                </option>
                                                                                                <option value="Uncontacted Lead 1st Month">
                                                                                                    Uncontacted Lead 1st Month
                                                                                                </option>
                                                                                                <option value="Quoted Not Booked">
                                                                                                    Quoted Not Booked
                                                                                                </option>
                                                                                                <option value="Not Quoted Not Booked">
                                                                                                    Not Quoted Not Booked
                                                                                                </option>
                                                                                                <option value="Unconverted Lead Long Term">
                                                                                                    Unconverted Lead Long Term
                                                                                                </option>
                                                                                                <option value="No Availability Wait List">
                                                                                                    No Availability Wait List
                                                                                                </option>
                                                                                                <option value="Booked 1st">Booked 1st</option>
                                                                                                <option value="Booked 2nd">Booked 2nd</option>
                                                                                                <option value="Booked 3rd">Booked 3rd</option>
                                                                                                <option value="Maturing">Maturing</option>
                                                                                                <option value="Fanatic">Fanatic</option>
                                                                                                <option value="Irregular">Irregular</option>
                                                                                                <option value="Innactive">Innactive</option>
                                                                                            </select>
                                                                                        </div>

                                                                                        <Button
                                                                                            className="btn btn-sm float-right add-user-btn ms-0"
                                                                                            onClick={getuserdata}
                                                                                        >
                                                                                            Get Data
                                                                                        </Button>

                                                                                        <CSVLink {...csvReport}>
                                                                                            <button className="btn btn-primary downloads-btn-preview me-1">Export CSV</button>
                                                                                        </CSVLink>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="card-body">
                                                                                <BootstrapTable
                                                                                    keyField="id"
                                                                                    data={staxdata}
                                                                                    columns={columns}
                                                                                    bordered
                                                                                    hover
                                                                                    condensed
                                                                                    pagination={paginationFactory()}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
        </div>
    );
}

export default CleaningFrequencyReport;